import React from 'react';
import { Link } from 'react-router-dom';
import '../../../CSS/content_row.scss';
import '../../../CSS/main.scss';
import {useLocation} from 'react-router-dom';

const ContentRow = ({data,rightAlign = true})=> {
// console.log(data);
const {pathname} = useLocation();
// const width = window.innerWidth;
return (
    <div className="row-section">
    <div className="container">
        {
            (rightAlign)? (
                <div className="row mt-5 mb-5" >
                    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                        <h5 className="header_or_link">{data.title}</h5>
                        <p>{data.content}</p>
                        {(pathname === '/main')? (<div>
                            <h5 className="header_or_link">
                                <Link className="header_or_link mb-5" to="main/portfolio">KNOW MORE
                                <span className="link_icon"><i class="fas fa-arrow-right"></i></span>
                                </Link>
                            </h5>
                        </div>): (<div></div>)
                        }
                    </div>
                    <div className="mb-5 col-md-6 col-lg-6 col-sm-12 col-xs-12">
                        <img src={data.image} width="350px" height="380px" />
                    </div>
                </div>
                ): (
                <div className="row mt-5 mb-5">
                    <div className="mb-5 col-md-6 col-lg-6 col-sm-12 col-xs-12">
                        <img src={data.image} width="300px" height="300px" />
                    </div>
                    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                        <h5 className="header_or_link">{data.title}</h5>
                        <p>{data.content}</p>
                        <h5 className="header_or_link">
                            {(pathname === '/main')? (<div>
                                <h5 className="header_or_link">
                                    <Link className="header_or_link mb-5" to="main/portfolio">KNOW MORE
                                    <span className="link_icon"><i class="fas fa-arrow-right"></i></span>
                                    </Link>
                                </h5>
                            </div>): (<div></div>)
                            }
                        </h5>
                    </div>
                </div>
                ) 
        }
    </div>
   </div>
);
}

export default ContentRow;